export default "__VITE_ASSET__44Ju$ZvN__"